import { render, staticRenderFns } from "./publicToPublic.vue?vue&type=template&id=4f3105c4&scoped=true&"
import script from "./publicToPublic.vue?vue&type=script&lang=js&"
export * from "./publicToPublic.vue?vue&type=script&lang=js&"
import style0 from "./publicToPublic.vue?vue&type=style&index=0&id=4f3105c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3105c4",
  null
  
)

export default component.exports